require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-about-us-disclosures.json") })
        }
      }, "path---es-about-us-disclosures");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-about-us-disclosures!./.cache/json/es-about-us-disclosures.json
// module id = 2018
// module chunks = 231608221292675